import { render, staticRenderFns } from "./CargoDetails.vue?vue&type=template&id=521d5c36&"
import script from "./CargoDetails.vue?vue&type=script&lang=js&"
export * from "./CargoDetails.vue?vue&type=script&lang=js&"
import style0 from "./CargoDetails.vue?vue&type=style&index=0&id=521d5c36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports